import { combineReducers } from 'redux'
import modules from '../modules'

const Reducers = Object.keys(modules).reduce((reducers, key)=>{
    reducers[key] = modules[key].reducer;
    return reducers;
}, {})

export default combineReducers(Reducers)


// WEBPACK FOOTER //
// ./src/store/rootReducer.js